/**
 * 支付模块公共文案配置
 * 所有品牌共享的文案
 */

import type { ChapterTexts, PayPageTexts, SubscribePageTexts } from './types'
import { t } from '@/i18n/utils'

/**
 * 充值页面公共文案
 */
export const payCommonTexts: PayPageTexts = {
  get tips() { return t('paymentTips') },
  get tip1() { return t('paymentTip1') },
  get tip2() { return t('paymentTip2') },
  get tip3() { return t('paymentTip3') },
  get coins() { return t('Coins') },
}

/**
 * 订阅页面公共文案
 */
export const subscribeCommonTexts: SubscribePageTexts = {
  get membership() { return t('Membership') },
  get vipMembership() { return t('VIPMembership') },
  get membershipDesc() { return t('VIPIncentive2') },
  get notJoinedYet() { return t('Identification') },
  get tips() { return t('subscriptionTips') },
  get tip1() { return t('subscriptionTip1') },
  get tip2() { return t('subscriptionTip2') },
  get free() { return t('subscriptionFree') },
  get buyNow() { return t('BuyNow') },
  payTemplateGetCoins(coins: string) { return t('payTemplateGetCoins', { coins }) },
  payTemplateEarnCoins(coins: string, daily: string) { return t('payTemplateEarnCoins', { coins, daily }) },
}

/**
 * 章节/阅读器页面公共文案
 */
export const chapterCommonTexts: ChapterTexts = {
  get loading() { return `${t('Loading')}...` },
  get unlockTitle() { return t('Unlock') },
  get unlockDesc() { return t('UnlockIncentive') },
  get unlockChapterButton() { return t('unlockChapterButton') },
  get unlockBookButton() { return t('unlockBookButton') },
  get continueInApp() { return t('ToApp') },
  get autoUnlock() { return t('AutoUnlock') },
  get coinsBalance() { return t('coinsBalance') },
  get prevButton() { return t('Prev') },
  get nextButton() { return t('Next') },
  get unlockButton() { return t('Unlock2') },
  get catalogueButton() { return t('Catalogue') },
  get themeSizeLabel() { return t('Size') },
  fontSizeDecrease: 'A-',
  fontSizeIncrease: 'A+',
  get coinsSuccessTitle() { return t('Congratulations') },
  get coinsSuccessDesc1() { return t('UnlimitedReadingDuring') },
  get coinsSuccessDesc2() { return t('UnlimitedReadingIncentive') },
  get coinsSuccessButton() { return t('OK') },
  get recommendTitle() { return t('Retention') },
  get recommendSeeAll() { return t('SeeAll') },
  get payTemplateTitle() { return t('ChapterLocked') },
  get payTemplateDesc() { return t('SelectGuide') },
  get payTemplateCoins() { return t('coins') },
  get payTemplateFree() { return t('payTemplateFree') },
  get payTemplateGetCoins() { return t('payTemplateGetCoins') },
  get payTemplateEarnCoins() { return t('payTemplateEarnCoins') },
}
